import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PalletSpecification, PalletType } from 'interfaces';

import {
   EDHP_PALLET_LOGISTIC_MINIMUM,
   EURO_PALLET_LOGISTIC_MINIMUM,
   HALF_PALLET_NDHP_LOGISTIC_MINIMUM,
   QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_LOWER_RANGE,
   QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_UPPER_RANGE,
} from './palletLogisticMinimums';

export const palletTypes: PalletType[] = [
   'EDHP_PALLET',
   'EURO_PALLET',
   'HALF_PALLET_NDHP',
   'QUARTER_PALLET_CDHP',
];

export const usePalletsTypes = () => {
   const { t } = useTranslation();

   const palletTypesData: PalletSpecification[] = useMemo(
      () => [
         {
            name: 'EDHP_PALLET',
            label: t('client_balance.table.edhp'),
            logisticMinimum: EDHP_PALLET_LOGISTIC_MINIMUM,
            dimensions: '800x1200 mm',
         },
         {
            name: 'EURO_PALLET',
            label: t('pallets.types.euro.label'),
            logisticMinimum: EURO_PALLET_LOGISTIC_MINIMUM,
            dimensions: '800x1200 mm',
         },
         {
            name: 'HALF_PALLET_NDHP',
            label: t('client_balance.table.ndhp'),
            logisticMinimum: HALF_PALLET_NDHP_LOGISTIC_MINIMUM,
            dimensions: '600x800 mm',
         },
         {
            name: 'QUARTER_PALLET_CDHP',
            label: t('client_balance.table.cdhp'),
            logisticMinimum: QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_LOWER_RANGE,
            logisticMinimumUpperRange: QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_UPPER_RANGE,
            dimensions: '400x600 mm',
         },
      ],
      [t],
   );

   const PALLET_TYPE_LABELS: { [key: string]: string } = useMemo(
      () => ({
         EDHP_PALLET: t('damageLossPalletsSummary.edhp'),
         EURO_PALLET: t('pallets.types.euro.fullLabel'),
         HALF_PALLET_NDHP: t('damageLossPalletsSummary.half'),
         QUARTER_PALLET_CDHP: t('damageLossPalletsSummary.quarter'),
      }),
      [t],
   );

   const PALLET_TYPES: Record<PalletType, PalletType> = useMemo(
      () => ({
         EDHP_PALLET: 'EDHP_PALLET',
         EURO_PALLET: 'EURO_PALLET',
         HALF_PALLET_NDHP: 'HALF_PALLET_NDHP',
         QUARTER_PALLET_CDHP: 'QUARTER_PALLET_CDHP',
      }),
      [],
   );

   const PALLET_TYPES_LABELS_WITH_DIMENSIONS = useMemo(
      () => ({
         EDHP_PALLET: {
            label: t('client_balance.table.edhp'),
            dimensions: '800x1200 mm',
         },
         EURO_PALLET: {
            label: t('pallets.types.euro.label'),
            dimensions: '800x1200 mm',
         },
         HALF_PALLET_NDHP: {
            label: t('client_balance.table.ndhp'),
            dimensions: '600x800 mm',
         },
         QUARTER_PALLET_CDHP: {
            label: t('client_balance.table.cdhp'),
            dimensions: '400x600 mm',
         },
      }),
      [t],
   );

   return {
      palletTypesData,
      PALLET_TYPE_LABELS,
      PALLET_TYPES,
      PALLET_TYPES_LABELS_WITH_DIMENSIONS,
   };
};
